import React, { useState, useEffect, useContext } from "react";

import db from "../../services/query";

import PrintHeader from "./common/PrintHeader";
import PrintBodyTitle from "./common/PrintBodyTitle";
import PrintTable from "./common/PrintTable";
import RowPhoto from "../common/TdImg";

const ClassStudents = (props) => {
  const [data, setData] = useState([]);

  let {class_desc, faculty, entry_year} = data?.summary ?? {};

  const titles = [
    class_desc,
    entry_year,
  ]

  let printHeadTexts = [
    "معاونیت امور محصلان",
    faculty
  ];


  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "student_photo",
      label: "عکس",
      content: ({ student_photo }) => <RowPhoto src={student_photo} />,
    },
    { path: "aria_id", label: "کد دانشجو" },
    { path: "student_name", label: "اسم" },
    { path: "student_father_name", label: "ولد" },
    { path: "student_phone", label: "شماره تماس" },
    { path: "faculty_name", label: "پوهنحی" },
    { path: "department_name", label: "دیپارتمنت" },
    { path: "class_desc", label: "صنف" },
    { path: "entry_year", label: "سال ورود" },
  ];

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    const { cid } = props.match.params;

    try {
      let query = `classes/${cid}/students`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });

    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    //  hide the table footer
    <main className="main-print-wrapper hide-table-summary class-students-print">
      <PrintHeader
        titles={titles}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default ClassStudents;
